export default __webpack_public_path__ + "static/media/SKS_CLinical.b39eeeb8.svg";